// extracted by mini-css-extract-plugin
module.exports = {"provider":"styles-module__provider___1jFzd"};